export default __webpack_public_path__ + "static/media/min2.70b4e616.JPG";